export default class TextSize {
    constructor() {
        this.element = document.querySelector('[data-text-size]');
        this.init();
    }

    init() {
        if (this.element === null) {
            return false;
        }

        const targetContainer = this.getContainer(this.element);
        if (targetContainer === null) {
            return;
        }

        const paragraphs = targetContainer.querySelectorAll('span, p, a');

        const links = this.getLinks(this.element);

        links.forEach((element) => {
            element.addEventListener('click', (e) => {
                const newSize = e.currentTarget.dataset.size;
                let size = null;
                let lineHeight = null;
                if (newSize === 'size3') {
                    size = '18px';
                    lineHeight = '34px';
                } else if (newSize === 'size2') {
                    size = '16px';
                    lineHeight = '30px';
                }

                paragraphs.forEach((paragraph) => {
                    paragraph.style.fontSize = size;
                    paragraph.style.lineHeight = lineHeight;
                });
            });
        });
    }

    getLinks(element) {
        return element.querySelectorAll('[data-size]');
    }

    getContainer(element) {
        return document.querySelector(element.dataset.target);
    }
}
